import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SettingIconSvg } from '../../../assets/icons/setting.svg';

export default function SettingIcon() {
  return <SvgIcon component={SettingIconSvg} />;
}
